import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { userService } from '../services/userService'
import type { UserCreateFormData, UserEditFormData } from '../types'

export function useUserMutation() {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const create = async (data: UserCreateFormData) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await userService.create(data)
      navigate('/users')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        if (err.response?.status === 409) {
          setError('Ya existe un vendedor con ese RUT o email')
        } else {
          setError(typeof detail === 'string' ? detail : 'Error al crear vendedor')
        }
      } else {
        setError('Error al crear vendedor')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const update = async (id: number, data: Partial<UserEditFormData>) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await userService.update(id, data)
      navigate('/users')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        if (err.response?.status === 409) {
          setError('Ya existe un vendedor con ese RUT o email')
        } else {
          setError(typeof detail === 'string' ? detail : 'Error al actualizar vendedor')
        }
      } else {
        setError('Error al actualizar vendedor')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const remove = async (id: number) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await userService.delete(id)
      navigate('/users')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al eliminar vendedor')
      } else {
        setError('Error al eliminar vendedor')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return { create, update, remove, isSubmitting, error }
}
